<template>
      <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <div class="main_home_content">
    <div class="container">
      <div class="row">
        <div class="col-md-10 offset-md-1 pt-1 pb-5" style="margin-top: 20px;">
          <div class="home-content">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-7 col-lg-6">
                <h2 class="right_heading">
                  Comprehensive Medical Records Organization & Sharing
                </h2>
                <h4 class="right_headline">
                  Centralize, Organize, and Share Medical Records with Ease
                </h4>
                <h5 class="right_content">
                  {{main_data}} Solution to Efficiently Manage and
                  Distribute Patient Medical Records
                </h5>
                <p class="right_content">
                  Maintaining an organized and easily accessible repository of
                  patient medical records is foundational for delivering
                  effective healthcare. With {{main_data}} system for
                  organizing and sharing medical records, healthcare
                  professionals can effortlessly manage, retrieve, and share
                  vital patient data, ensuring seamless continuity of care.
                </p>
                <div style="margin-top: 50px;"></div>
              </div>
              <div class="col-md-12 col-lg-5">
                <img style="height: 400px;"
                  src="@/assets/img/medicalrecords.jpeg"
                  class="img-fluid"
                  alt="Doccure Login"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h3 style="text-align: center; margin-bottom: 40px; margin-top: 20px;">
        Centralized Medical Records Repository
      </h3>
    </div>

    <div>
      <div class="row mt-1">
        <div class="col-md-10 offset-md-1">
          <!-- <p><strong>Healthcare Practitioner Schedules:</strong></p> -->
          <b-card-group deck>
            <b-card
              border-variant="dark"
              header="One Place for All Records"
              header-bg-variant="dark"
              header-text-variant="white"
              style="font-size: 20px;"
            >
              <b-card-text style="font-size: 17px;"
                >Store all patient medical records in a centralized digital
                repository, making it easy to access, update, and manage
                them.</b-card-text
              >
            </b-card>
            <b-card
              border-variant="dark"
              header="Find What You Need, When You Need It"
              header-bg-variant="dark"
              header-text-variant="white"
            >
              <b-card-text
                >Categorize and organize records based on various criteria, such
                as date, type of record, medical condition, etc. This ensures
                quick retrieval and minimizes time spent searching
              </b-card-text>
            </b-card>
            <b-card
              border-variant="dark"
              header="Share Records with Confidence"
              header-bg-variant="dark"
              header-text-variant="white"
            >
              <b-card-text
                >Share specific medical records with other healthcare
                professionals, specialists, or patients while ensuring data
                privacy and security." Integration with Diagnostic
                Tools</b-card-text
              >
            </b-card>
          </b-card-group>
          <b-card-group deck style="margin-top: 30px;">
            <b-card
              border-variant="dark"
              header="Seamless Integration for Comprehensive Data"
              header-bg-variant="dark"
              header-text-variant="white"
              style="font-size: 20px;"
            >
              <b-card-text style="font-size: 17px;"
                >Automatically integrate data from diagnostic tools and lab
                results into the patient's medical records, ensuring a holistic
                view of the patient's health.</b-card-text
              >
            </b-card>
            <b-card
              border-variant="dark"
              header="Control Who Sees What"
              header-bg-variant="dark"
              header-text-variant="white"
            >
              <b-card-text
                >Set permissions and control access to sensitive medical
                records, ensuring that only authorized individuals can view or
                modify them
              </b-card-text>
            </b-card>
            <b-card style="border: none;">
              <b-card-text></b-card-text>
            </b-card>
          </b-card-group>
        </div>
      </div>

      <h3 style="text-align: center; margin-bottom: 20px; margin-top: 60px;">
        The Future of Prescription Management
      </h3>
    </div>

    <div>
      <h4 style="text-align: center; margin-top: 3px; margin-bottom: 40px;">
        Redefining Medical Records Management
      </h4>
    </div>
    <div class="mt-6">
      <div>
        <div class="row mt-1" >
          <div class="col-md-10 offset-md-1">
            <!-- <p><strong>Healthcare Practitioner Schedules:</strong></p> -->
            <b-card-group deck>
              <b-card
                border-variant="dark"
                header="Professionalism"
                header-bg-variant="dark"
                header-text-variant="white"
                style="font-size: 20px;"
              >
                <b-card-text style="font-size: 17px;"
                  >Strengthen your hospital's brand with every prescription
                  issued.</b-card-text
                >
              </b-card>
              <b-card
                border-variant="dark"
                header="Efficiency"
                header-bg-variant="dark"
                header-text-variant="white"
              >
                <b-card-text
                  >Quickly access and manage patient records, streamlining the
                  care process. Collaboration: Facilitate interdisciplinary care
                  by sharing pertinent medical records with other professionals.
                </b-card-text>
              </b-card>
              <b-card
                border-variant="dark"
                header="Security"
                header-bg-variant="dark"
                header-text-variant="white"
              >
                <b-card-text>
                  Rest assured that all patient data is stored securely and
                  shared with utmost confidentiality.</b-card-text
                >
              </b-card>
            </b-card-group>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5"
      style="display: flex; justify-content: center; align-items: center;"
    >
      <div style="width: 500px; text-align: center;">
        <b-card bg-variant="info" text-variant="white" title="" style="border:1px solid black">
          <b-card-text>
            "Step into the next generation of medical records management with
            {{main_data}} Register today to experience unparalleled
            efficiency and security in handling patient data!"
          </b-card-text>

          <b-button href="#" variant="dark" style="text-align: center;"
            >Register Now</b-button
          >
        </b-card>
      </div>
    </div>
  </div>
    <layout-footer></layout-footer>
    </div>
    </div>
  </template>
  
  <script>
  import config from "../../services/CommonApi";
  import axios from "axios";
  export default {
    data() {
      return {
        main_data: "",
        config: config,
      };
    },
    mounted() {
      this.get_practitioner_profile();
    },
    methods: {
  
      async get_practitioner_profile() {
        var domain = window.location.hostname;
  
        const formdata = {
          domain: window.location.hostname,
        };
        await axios
          .get(
            "https://app.bhilwarahealthcare.in/api/method/sahaj.domain.get_hospital?domain=" +
            window.location.hostname
          )
          .then((res) => {
            this.showspinner = false;
            if (res.data.status_code == 200) {
              this.main_data = res.data.data[0].brand_name
            }
            if (res.data.status_code == 404) {
              if (window.location.hostname == "bhilwarahealthcare.in") {
              } else if (window.location.hostname == "localhost") {
              } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
              } else {
                window.location.href = String("https://bhilwarahealthcare.in");
              }
            }
            this.$swal.close();
          });
      },
  
    },
  }
  </script>
  
  <style>
  .right_heading {
    font-size: 40px;
    font-weight: bold;
    font-family: sans-serif;
  }
  
  .right_content {
    font-size: 16px;
    margin-top: 20px;
    font-family: sans-serif;
  }
  .right_headline {
    margin-top: 20px;
  }
  .btn {
    border-radius: 10px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/kneexpert/Comprehensive.vue